import { StyleRules } from '@material-ui/core/styles';
import { AccordionDetailsClassKey } from '@material-ui/core/AccordionDetails';

export const MuiAccordionDetails: Partial<StyleRules<
  AccordionDetailsClassKey
>> = {
  root: {
    display: 'block',
    padding: '0 2rem 2rem',
  },
};
